import { ReactNode } from 'react';

import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import { Inline } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';

type Props = {
  children: ReactNode;
  tooltipText?: string;
};

export const HeaderWithHelpIcon = ({ children, tooltipText }: Props) => {
  return (
    <Inline space="space.050" alignBlock="center">
      {children}
      <Tooltip content={tooltipText} canAppear={() => !!tooltipText}>
        <QuestionCircleIcon label="" size="small" />
      </Tooltip>
    </Inline>
  );
};
